/** Created by azhou on 2019/3/27.*/
<template>
  <div class="order-list-item bg-white">
    <div class="d-center-between mb-2">
      <p class="d-center-start"><left-text leftText="订单号"/>{{cardItem.order_no}}</p>
      <span class="text-muted ml-auto">发布时间：{{cardItem.time | formatTimestamp(1)}}</span>
    </div>
    <div class="d-flex align-items-center">
      <div>
        <p class="mb-2"><span class="text-blue h5 ml-2">{{cardItem.title}}</span></p>
        <p class="d-center-start mb-2"><left-text leftText="联系人"/>{{cardItem.contact}}（{{cardItem.mobile}}）</p>
        <p class="d-center-start mb-2"><left-text leftText="数量"/>{{cardItem.num}} 张</p>
        <p class="d-center-start mb-2"><left-text leftText="订单价格"/>{{cardItem.price | formatMoney}} 元</p>
        <p class="d-center-start">
          <left-text leftText="订单状态"/>
          <span :class="[$GFUN.FormatColor(cardItem.status)]">{{cardItem.status | formatVar('YOrderStatus')}}</span>
        </p>
      </div>
      <!--<el-button @click="$emit('goForDetail',cardItem)" class="ml-auto">查看详情</el-button>-->
      <el-button @click="$router.push({name:'PaymentDetail',query:{data:cardItem.id,status:cardItem.status}})" class="ml-auto">查看详情</el-button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'YearCard',
    props: {
      cardItem: {}
    },
    computed: {
      ...mapGetters(['storeInfo']),
    },
  }
</script>
